






































































































































































































































































































































































































































import SearchBreadcrumb from '~/components/molecules/SearchBreadcrumb'
import SearchInput from '~/components/molecules/SearchInput'
import CPagination from '~/components/molecules/CPagination'
import HeadBanner from '~/components/organisms/HeadBanner'
import ServiceSearchHeader from '~/components/organisms/ServiceSearchHeader'
import ServiceListItemV2 from '~/components/organisms/ServiceListItemV2'
import ServiceBlockItemV2 from '~/components/organisms/ServiceBlockItemV2'
import ServiceSearchHeaderBanner from '~/components/organisms/ServiceSearchHeaderBanner'
import GlobalPopup from '~/components/organisms/GlobalPopup'
import TheVueport from '~/components/organisms/TheVueport'
import ServiceSearchBottomSeo from '~/components/organisms/ServiceSearchBottomSeo'
import ServiceSearchBottomDisclaimer from '~/components/organisms/ServiceSearchBottomDisclaimer'
import SearchTitle from '~/components/organisms/SearchTitle'
import RecentOrderService from '~/components/organisms/RecentOrderService'
import RecentOrderServiceList from '~/components/organisms/RecentOrderServiceList'
import CategoryList from '~/components/organisms/CategoryList'
import CategoryListForSeo from '~/components/organisms/CategoryListForSeo'
import SubCategoryListForSeo from '~/components/organisms/SubCategoryListForSeo'
import CategoryTypeListForSeo from '~/components/organisms/CategoryTypeListForSeo'
import CategoryTechniqueListForSeo from '~/components/organisms/CategoryTechniqueListForSeo'
import ServiceSearchParentCategoryContent from '~/components/organisms/ServiceSearchParentCategoryContent'
import CategoryRatingSeo from '~/components/organisms/CategoryRatingSeo'
import ServiceSearchHeaderFacet from '~/components/organisms/ServiceSearchHeaderFacet'

import businessMixin from '~/mixins/pages/business-mixin'

import grpcClient from '~/grpc/grpc-client'
import { toInt32, toInt32Array } from '~/grpc/grpc-util'
import { GetTopRequest } from '~/stub/apigateway/category/top_pb'
import { TopService } from '~/stub/apigateway/category/top_pb_service'
import { GetSeoRequest } from '~/stub/apigateway/category/seo_pb'
import { SeoService } from '~/stub/apigateway/category/seo_pb_service'
import { commonMetaData } from '~/store/_helpers/common-helper'
import { SearchServiceRequest } from '~/stub/apigateway/service/search_pb'
import ServicePrAccessor from '~/api/accessors/mypage/service-pr-accessor'

import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'
import { defineComponent } from '@nuxtjs/composition-api'
import { SERVICE_KIND_VALUE } from '~/constants/search'

const SORT_DEFAULT_VALUE = 'recommend'

const CATEGORY_DIVINATION = {
  id: 3,
  name: '占い'
}

const SERVICE_PR_CASSETTES_OF_BLOCK = 8
const SERVICE_PR_CASSETTES_OF_LIST = 4

const IGNORE_QUERIES = ['exclude_full_correspondence', 'layout', 'sort_by']

/** サービス検索結果のカセットに引き継ぐrefパラメータ */
const TAKEOVER_REFS = Object.freeze(['category_popular_subcategories', 'category_tags'])

/**
 * 有効なserviceKindかチェック
 * @param {string} serviceKind
 */
const isValidServiceKind = serviceKind => Object.values(SERVICE_KIND_VALUE).includes(serviceKind)

/**
 * 大カテTOPとして判定しないクエリパラメータのリスト
 * サービス検索リクエスト(SearchServiceRequest)のフィールドから生成
 */
const EXCLUDED_QUERIES_PARENT_CATEGORY = Object.freeze(
  Object.keys(new SearchServiceRequest().toObject())
    // ソート順、満枠非表示フラグ、レイアウト、ビジネスプレビューフラグは除外する
    .filter(
      f =>
        !['sortBy', 'excludeFullCorrespondence', 'layout', 'isBusiness', 'businessFlag'].includes(f)
    )
    // 末尾のListを削除してスネークケース化
    .map(f => f.replace(/List$/, '').replace(/[A-Z]/g, s => `_${s.toLowerCase()}`))
)

const FOOTER_BOTTOM_SP = '120px'

// GTM用のグローバル変数の宣言
declare global {
  interface Window {
    dataLayer: object[]
  }
}

const searchService = defineComponent({
  name: 'searchService',
  components: {
    SearchBreadcrumb,
    SearchInput,
    CPagination,
    CoconalaMerit: () =>
      import(
        '~/components/organisms/ServiceSearchParentCategoryContent/components/CoconalaMerit.vue' /* webpackChunkName: "ServiceSearchCoconalaMerit" */
      ),
    FixedServiceAdd: () =>
      import('~/components/molecules/FixedServiceAdd' /* webpackChunkName: "FixedServiceAdd" */),
    HeadBanner,
    ServiceSearchHeader,
    ServiceSearchForm: () =>
      import(
        '~/components/organisms/ServiceSearchForm' /* webpackChunkName: "ServiceSearchForm" */
      ),
    ServiceListItemV2,
    ServiceBlockItemV2,
    ServiceSearchPhoneHelp: () =>
      import(
        '~/components/organisms/ServiceSearchPhoneHelp' /* webpackChunkName: "ServiceSearchPhoneHelp" */
      ),
    ServiceSearchHeaderBanner,
    ServiceSearchRequestBanner: () =>
      import(
        '~/components/organisms/ServiceSearchRequestBanner' /* webpackChunkName: "ServiceSearchRequestBanner" */
      ),
    ServiceSearchLegalBanner: () =>
      import(
        '~/components/organisms/ServiceSearchLegalBanner' /* webpackChunkName: "ServiceSearchLegalBanner" */
      ),
    DLegalSearchIntroductionArea: () =>
      import(
        '~/components/organisms/DS2/DLegalSearchIntroductionArea' /* webpackChunkName: "DLegalSearchIntroductionArea" */
      ),
    ServiceSearchParentCategoryContent,
    GlobalPopup,
    TheVueport,
    BottomFixedBar: () =>
      import('~/components/organisms/BottomFixedBar' /* webpackChunkName: "BottomFixedBar" */),
    ServiceSearchBottomSeo,
    ServiceSearchBottomDisclaimer,
    SearchTitle,
    SearchLp: () => import('~/components/organisms/SearchLp' /* webpackChunkName: "SearchLp" */),
    RecentOrderService,
    RecentOrderServiceList,
    CategoryList,
    CategoryListForSeo,
    SubCategoryListForSeo,
    CategoryTypeListForSeo,
    CategoryRatingSeo,
    CategoryTechniqueListForSeo,
    ServiceSearchHeaderFacet,
    ServiceSearchFormV2: () =>
      import(
        '~/components/organisms/DS2/ServiceSearchFormV2' /* webpackChunkName: "ServiceSearchFormV2" */
      )
  },
  mixins: [businessMixin],
  head() {
    return this.head
  },
  data() {
    return {
      keyword: this.$route.query.keyword,
      bread: {
        type: 'search',
        breadcrumb: []
      },
      openedCategoryIds: [],
      /** 大カテTOPコンテンツデータ */
      parentCategoryTopData: null,
      hasFetched: false,
      // TODO: category_v2 型推論が効かなくなってエラーになっていたので一旦ignoreする
      // @ts-ignore
      attributes: this.getMergedAttributes(this.$util.castQueryFields(this.$route.query)),
      footerBottomBeforeMountedSp: '32px',
      isFixedSearchCondition: false
    }
  },
  watch: {
    $route() {
      this.$fetch()
      this.isFixedSearchCondition = false
    },
    hasFetched: {
      immediate: true,
      handler(newValue) {
        if (newValue) {
          this.setGoogleOptimizeEventToDataLayer()
        }
      }
    }
  },
  created() {
    this.keyword = this.$route.query.keyword ? this.$route.query.keyword : null
    this.generateBread()
    this.pushDefaultOpenedCategoryIds()
  },
  mounted() {
    // Criteo用のGTM dataLayer push処理(カテゴリページの場合)、Penglue用にparent_category_id追加
    if (this.isCategoryPage) {
      const data = { pagetype: 'searchresults' }
      this.search.searchResultsList.forEach((service, i) => {
        data[`service_id_${i + 1}`] = String(service.service.id)
      })
      data['parent_category_id'] = this.parentCategoryId
      if (!Array.isArray(window.dataLayer)) {
        window.dataLayer = []
      }
      window.dataLayer.push(data)
    }

    this.footerBottomBeforeMountedSp = this.$store.state.ui.footerBottomSp
    this.updateFooterBottomSp(FOOTER_BOTTOM_SP)
  },
  beforeDestroy() {
    this.updateFooterBottomSp(this.footerBottomBeforeMountedSp)
  },
  async fetch() {
    if (process.client) {
      const y = this.$util.castToNumberQueryString(this.$route.query.y)
      const page = this.$util.castToNumberQueryString(this.$route.query.page)
      if (this.isSP || this.isTB || !y || page) {
        this.$scrollTo(document.body, -1)
      }
    }
    // 検索時、SP画面下部のカテゴリリスト（accordion）は一度全閉じする。検索の後続処理で、自動展開対象があれば開く
    this.openedCategoryIds = []
    await Promise.all([this.getSearchServices(), this.getSeo(), this.getParentCategoryTop()])
    this.generateBread()
    this.pushDefaultOpenedCategoryIds()
    this.attributes = this.getMergedAttributes(this.$util.castQueryFields(this.$route.query))
    this.hasFetched = true
  },
  computed: {
    ...mapState('pages/search', ['search']),
    ...mapState('master', ['optionMastersList', 'masterCategories', 'masterCategoryTypesList']),
    ...mapState('pages/search', ['seo']),
    ...mapState('constants', ['serviceClass', 'VIRTUAL_CATEGORY']),
    ...mapState('auth', ['user']),
    ...mapState('auth/user', ['isBusiness']),
    ...mapGetters('ui', ['isPC', 'isTB', 'isSP']),
    ...mapGetters('auth', ['isFromCoconalaApp', 'isLoggedIn']),
    ...mapGetters('master', ['flattenMasterCategories']),
    /**
     * 上部の検索条件の作成
     */
    // TODO: category_v2 不要になった関数。確認後削除する。
    isSearviceSearchHeaderFacet() {
      const masterCategoryId = this.currentCategoryId
      const facets = this.optionMastersList.filter(optionMaster => {
        // 出品者ランクの絞り込み条件は全カテ、全検索結果に出すので、masterCategoryIdは条件に含めず、searchDisplayPositionがtopに指定されたものを強調絞り込みに表示する
        if (optionMaster.key === 'provider_levels') {
          return optionMaster.searchDisplayPosition === 'top'
        }
        // 出品者ランク以外はkeyCategoryIdの値がoptionMasterのキー＋masterCategoryIdになっていて、searchDisplayPositionがtopに指定されたものを強調絞り込みに表示する
        return (
          optionMaster.keyCategoryId === `${optionMaster.key}${masterCategoryId}` &&
          optionMaster.searchDisplayPosition === 'top'
        )
      })
      const relatedCategoryIds = this.search.searchCondition.conditionOptionsList?.filter(o => {
        return o.relatedCategoryId
      })
      return facets?.length > 0 || relatedCategoryIds?.length > 0
    },
    isLoading() {
      return this.$fetchState.pending
    },
    currentCategoryId() {
      if (this.$route.params.categoryId) {
        return Number(this.$route.params.categoryId)
      }
      if (this.$route.query.category_id) {
        return this.$util.castToNumberQueryString(this.$route.query.category_id)
      }
      return null
    },
    currentCategoryTypeId() {
      if (this.$route.params.categoryTypeId) {
        return Number(this.$route.params.categoryTypeId)
      }
      if (this.$route.query.category_type_id) {
        return this.$util.castToNumberQueryString(this.$route.query.category_type_id)
      }
      return null
    },
    currentCategoryTypeName() {
      if (this.currentCategoryId && this.currentCategoryTypeId) {
        const categoryTypes =
          this.masterCategoryTypesList.find(i => i.masterCategoryId === this.currentCategoryId)
            ?.masterCategoryTypesList || []
        return categoryTypes.find(i => i.id === this.currentCategoryTypeId)?.name || ''
      }
      return ''
    },
    parentCategoryId() {
      if (this.currentCategoryId && this.search.searchCondition.categoriesList.length) {
        return Number(this.search.searchCondition.categoriesList[0].id)
      }
      return null
    },
    isParentCategory() {
      if (!this.currentCategoryId) {
        return false
      }
      return this.currentCategoryId === this.parentCategoryId
    },
    isParentCategoryTop() {
      return this.isParentCategory && this.isParentCategoryTopFromQueries()
    },
    childCategoryId() {
      if (this.currentCategoryId && !this.isParentCategory) {
        return Number(this.currentCategoryId)
      }
      return null
    },
    /**
     * SP画面下部のカテゴリリスト（accordion）で自動展開する対象の大カテID（0: PRO認定カテゴリ一覧を指す便宜的な値）
     * @return Number | null
     */
    defaultOpenedCategoryId() {
      // PRO認定の検索条件を2つ満たし、かつ、【PRO認定カテゴリに属する大カテが選択されている場合 または カテゴリ未選択の場合】、カテゴリリストのPRO認定を展開表示する
      const isOpenPro = () => {
        let proPriorityDisplay = this.$cookies.get('pro_priority_display')
        if (this.$route.query.pro_priority_display) {
          proPriorityDisplay = this.$route.query.pro_priority_display
        }
        // cookie.getで取得した値も文字列の可能性があるので変数に対してキャストを行う
        proPriorityDisplay = this.$util.castToNumberQueryString(proPriorityDisplay)

        // provider_statusesは文字列のためキャスト不要
        const providerStatuses = this.$route.query.provider_statuses
        const isOnlyProService =
          Array.isArray(providerStatuses) && providerStatuses.includes('pro_service')

        const isProParentCategory = this.masterCategories
          .filter(c => c.isPro)
          .map(c => c.id)
          .includes(this.currentCategoryId)

        return (
          proPriorityDisplay === 1 &&
          isOnlyProService &&
          (isProParentCategory || this.currentCategoryId === null)
        )
      }

      if (isOpenPro()) {
        return 0
      }
      return this.parentCategoryId
    },
    isCategoryPage() {
      return !!this.$route.params.categoryId
    },
    currentCategoryName() {
      const categoryId = this.currentCategoryId
      if (!categoryId) {
        return null
      }

      let categoryName =
        this.flattenMasterCategories.find(category => category.id === categoryId)?.name || ''

      // 占いカテゴリ且つ電話サービスの時にカテゴリ名変更
      if (this.isCategoryDivinationPhone) {
        categoryName = this.VIRTUAL_CATEGORY.DIVINATION_PHONE.NAME
      }

      return categoryName
    },
    currentCategoryTitle() {
      if (this.currentCategoryId === null) {
        return 'すべて'
      }

      const camelQuery = this.$util.toCamelCaseObject(this.$route.query)
      const serviceClass = Number(camelQuery.serviceClass)

      let categoryTitle = this.currentCategoryName

      // 占い以外のカテゴリ且つ電話サービスはタイトル加工
      if (!this.isCategoryDivinationPhone && serviceClass === this.serviceClass.phone) {
        categoryTitle += 'の電話相談'
      }

      return categoryTitle
    },
    currentServiceClass() {
      const serviceClass = this.$util.castToNumberQueryString(
        this.$route.query.service_class || this.$route.query.service_kind
      )
      if (typeof serviceClass === 'number') {
        return serviceClass
      }
      return null
    },
    isFromAd() {
      return this.$route.query.from_ad ? true : false
    },
    isList() {
      return (
        this.$store.state.constants.serviceLayout.list &&
        Number(this.search.searchCondition.layout) ===
          this.$store.state.constants.serviceLayout.list
      )
    },
    // 占いカテゴリの判定
    isCategoryDivination() {
      return this.parentCategoryId === CATEGORY_DIVINATION.id
    },
    // 占いカテゴリ且つ電話サービスの判定
    isCategoryDivinationPhone() {
      return (
        this.currentCategoryId === this.VIRTUAL_CATEGORY.DIVINATION_PHONE.CONDITION.CATEGORY_ID &&
        this.currentServiceClass === this.VIRTUAL_CATEGORY.DIVINATION_PHONE.CONDITION.SERVICE_CLASS
      )
    },
    // 親カテが占いカテゴリ且つ電話サービスの判定
    isParentCategoryDivinationPhone() {
      return (
        this.parentCategoryId === this.VIRTUAL_CATEGORY.DIVINATION_PHONE.CONDITION.CATEGORY_ID &&
        this.currentServiceClass === this.VIRTUAL_CATEGORY.DIVINATION_PHONE.CONDITION.SERVICE_CLASS
      )
    },
    // パンクズに技術（占いでいう「占術」）を追加するページ条件かの判定
    isMixinBreadcrumbTechniques() {
      return (
        this.seo.isTagPage &&
        this.currentTechniques.length > 0 &&
        // NOTE: 電話占い、電話占いの子カテの場合のみ占術を表示
        (this.isCategoryDivinationPhone || this.isParentCategoryDivinationPhone)
      )
    },
    // 選択中の技術（占いでいう「占術」）
    currentTechniques() {
      // URLに技術の指定がない場合は早期リターン
      if (!this.$route.query.technique_ids) {
        return []
      }

      const techniqueOptions = this.conditionOptionsCommon.find(o => {
        return o.master.key === 'technique_ids'
      })

      if (!techniqueOptions) {
        return []
      }
      const selectedIds = techniqueOptions.option?.valuesList || []
      return techniqueOptions.master?.valuesList.filter(v => selectedIds.includes(v.value)) || []
    },
    // LPを表示するかの判定
    isLp() {
      return !this.isLoggedIn && this.$route.params.categoryId && !this.isRefC() && !this.isPage()
    },
    // 大カテのリンク一覧を表示するかの判定
    isCategoryListForSeo() {
      return (
        !this.isBusinessMode &&
        !this.isLoggedIn &&
        this.isParentCategory &&
        !this.currentCategoryTypeId &&
        !this.seo.isTagPage &&
        !this.seo.isTrendKeywordPage
      )
    },
    // 小カテのリンク一覧を表示するかの判定
    isSubCategoryListForSeo() {
      return (
        !this.isBusinessMode &&
        !this.isLoggedIn &&
        (this.isParentCategory || this.childCategoryId) &&
        !this.currentCategoryTypeId &&
        !this.seo.isTagPage &&
        !this.seo.isTrendKeywordPage
      )
    },
    // カテゴリタイプのリンク一覧を表示するかの判定
    isCategoryTypeListForSeo() {
      return (
        !this.isBusinessMode &&
        !this.isLoggedIn &&
        (this.childCategoryId || this.currentCategoryTypeId) &&
        !this.seo.isTagPage &&
        !this.seo.isTrendKeywordPage
      )
    },
    // 技術（占いでいう「占術」）のリンク一覧を表示するかの判定
    isCategoryTechniqueListForSeo() {
      return (
        !this.isBusinessMode &&
        !this.isLoggedIn &&
        !this.seo.isTagPage &&
        !this.seo.isTrendKeywordPage &&
        // NOTE: 2021.10.21 「電話占いトップ」の場合のみ出す
        this.isCategoryDivinationPhone
      )
    },
    layoutType() {
      if (
        this.$store.state.constants.serviceLayout.list &&
        Number(this.search.searchCondition.layout) ===
          this.$store.state.constants.serviceLayout.list
      ) {
        return 'List'
      }
      return 'Block'
    },
    head() {
      const head = {
        __dangerouslyDisableSanitizers: ['script'],
        title: this.metaTitle,
        link: [{ rel: 'canonical', href: this.metaCanonical }],
        bodyAttrs: {
          class: ['searchService']
        }
      }

      if (!this.isBusinessMode) {
        // NOTE: category_v2 lang="ts"化した時に型定義エラーになったため一旦ignoreしておく
        // @ts-ignore
        head.script = [
          {
            hid: 'json-ld-breadcrumb',
            type: 'application/ld+json',
            innerHTML: this.$util.escapeBreadcrumb(this.jsonLdBreadcrumb)
          }
        ]
      }

      const meta = [
        {
          hid: 'description',
          name: 'description',
          content: this.metaDescription
        }
      ]
      // /searchを想定(それ以外の場合は共通のog:description)
      if (!this.seo.metaDescription) {
        meta.push({
          hid: 'og:description',
          name: 'og:description',
          content: this.metaDescription
        })
      }
      // conditionOptionが2つ以上選択されていたらnoindex
      const selectedOptionCount =
        this.search.searchCondition.conditionOptionsList
          ?.map(co => co.valuesList.length)
          .reduce((a, b) => a + b) || 0
      if (Number(this.search.total) === 0 || selectedOptionCount > 1) {
        meta.push({
          hid: 'robots',
          name: 'robots',
          content: 'noindex,nofollow'
        })
      }
      meta.push({
        hid: 'keywords',
        name: 'keywords',
        content: this.metaKeywords
      })

      return Object.assign(head, { meta })
    },
    metaTitle() {
      if (this.isBusinessMode) {
        if (this.$route.query.keyword) {
          return `「${this.$route.query.keyword}」から探す | ココナラ`
        }

        if (this.$route.params.categoryId) {
          return `${this.currentCategoryName} | ココナラ`
        }
      }

      // /searchを想定
      if (!this.seo.metaTitle) {
        return 'すべてのカテゴリから探す | ココナラ'
      }
      return this.seo.metaTitle
    },
    metaDescription() {
      // /searchを想定
      if (!this.seo.metaDescription) {
        return 'サービス検索ページ。ココナラは、いろんなジャンルの「仕事」や「相談」をネットショッピングのように早く・簡単・おトクに依頼できます！ロゴや名刺などのデザイン、動画・サイト制作、お悩み相談など、ビジネスやプライベートで自分ではできないことをプロや専門家に依頼しませんか？No.1スキルマーケットのココナラ！'
      }
      return this.seo.metaDescription
    },
    metaCanonical() {
      // /searchを想定
      if (!this.seo.canonical) {
        return 'https://coconala.com/search'
      }
      return this.seo.canonical
    },
    metaKeywords() {
      // /searchを想定
      if (!this.seo.keywords) {
        return 'スキルマーケット,マーケットプレイス,ココナラ,coconala,ここなら'
      }
      return this.seo.keywords
    },
    offset() {
      const page = Number(this.search.searchCondition.page)
      const perPage = Number(this.search.searchCondition.perPage)
      if (page && page > 1) {
        return perPage * (page - 1)
      }
      return 0
    },
    /*
      NOTE: サービスPRの枠数は1ページごとにBLOCKで8枠、LISTで4枠用意する
      サービスPRのoffsetは枠数全てにPRサービスが表示されたものとしてカウントする
    */
    prOffset() {
      const page = Number(this.search.searchCondition.page)
      if (page && page > 1) {
        return this.layoutType === 'Block'
          ? SERVICE_PR_CASSETTES_OF_BLOCK * (page - 1)
          : SERVICE_PR_CASSETTES_OF_LIST * (page - 1)
      }
      return 0
    },
    hasPrService() {
      return this.search.searchResultsList.some(s => !!s.servicePr?.sprKey)
    },
    totalCountText() {
      return this.isLoading ? '-' : this.$util.numberWithDelimiter(Number(this.search.total))
    },
    startCountText() {
      return this.$util.numberWithDelimiter(this.offset + 1)
    },
    endCount() {
      let endCount = this.offset + Number(this.search.searchCondition.perPage)
      if (endCount > Number(this.search.total)) {
        endCount = Number(this.search.total)
      }
      return endCount
    },
    endCountText() {
      return this.$util.numberWithDelimiter(this.endCount)
    },
    jsonLdBreadcrumb() {
      const breadTop = [
        {
          '@type': 'ListItem',
          position: 1,
          item: {
            '@id': 'https://coconala.com',
            name: 'ココナラTOP'
          }
        }
      ]

      const breads = this.bread.breadcrumb.map((item, index) => ({
        '@type': 'ListItem',
        position: index + 2,
        item: {
          '@id': `https://coconala.com${item.url}`,
          name: item.name
        }
      }))

      const items = breadTop.concat(breads)

      return {
        '@context': 'http://schema.org',
        '@type': 'BreadcrumbList',
        itemListElement: items
      }
    },
    isDisplayRequestBanner() {
      return this.endCount === Number(this.search.total) && !this.isSearchingLegalThing
    },
    isDisplayCategoryListTop() {
      const query = this.$util.castQueryFields(this.$route.query)
      return (
        !this.$route.params.categoryId &&
        !query.category_id &&
        !query.keyword &&
        !query.pro_priority_display &&
        !query.page &&
        !(query.service_class || query.service_kind) &&
        !query.ref_c
      )
    },
    isDisplayMainBottom() {
      return (
        !this.isLoggedIn ||
        this.isCategoryDivination ||
        (this.isBeginner && this.isFirstPage && !this.isParentCategoryTop)
      )
    },
    isDisplayLegalSearchIntroductionArea() {
      return this.search.total === 0 && this.isSearchingLegalThing
    },
    isSearchingLegalThing() {
      return /^.*((?=法律)(?=.*相談)|弁護士).*$/.test(this.$route.query.keyword)
    },
    /** 初心者チェック */
    isBeginner() {
      return !this.isLoggedIn || !this.user?.hasBoughtService
    },
    isFirstPage() {
      const page = this.$util.castToNumberQueryString(this.$route.query.page)
      if (typeof page !== 'number') {
        return true
      }
      return page <= 1
    },
    /**
     * カテゴリ固有の検索条件 (top, side統合版)
     */
    conditionOptionsCommon() {
      if (!this.search.searchCondition.conditionOptionsList) {
        return []
      }
      return this.search.searchCondition.conditionOptionsList
        .map(option => {
          const master = this.optionMastersList.find(e => e.keyCategoryId === option.keyCategoryId)
          // マスターの存在しない検索オプションは除外する
          if (!master) {
            return null
          }
          return {
            option,
            master
          }
        })
        .filter(x => !!x)
    },
    isBusinessBeforeLogin() {
      return !!this.$route.query.is_business
    },
    isBusinessMode() {
      return this.isBusiness || this.isBusinessBeforeLogin
    }
  },
  methods: {
    ...mapActions('ui', ['updateFooterBottomSp']),
    ...mapMutations('my/header', ['TOGGLE_SEARCH_DRAWER']),
    switchSearchConditionPosition(value) {
      this.isFixedSearchCondition = value
    },
    resetAttributes() {
      const query = this.$util.toCamelCaseObject(this.$route.query)
      this.attributes = this.getMergedAttributes(query)
    },
    getMergedAttributes(newValue = {}) {
      // newValueへのSide effect防止
      newValue = this.$util.clone(newValue)
      IGNORE_QUERIES.forEach(k => {
        delete newValue[k]
      })
      const camelValue = this.$util.toCamelCaseObject(newValue)
      const categoryId = this.$route.params.categoryId || this.$route.query.category_id
      const categoryTypeId = this.$route.params.categoryTypeId || this.$route.query.category_type_id
      const attributes = {
        categoryId: categoryId ? Number(categoryId) : null,
        categoryTypeId: categoryTypeId ? Number(categoryTypeId) : null
      }
      return Object.assign(attributes, camelValue)
    },
    setAttributes(param) {
      // keyをキャメルケース化
      const key = param.key.replace(/_([a-z])/g, (_, p) => p.toUpperCase())
      const { value, emitChangeEvent } = param
      this.$set(this.attributes, key, value)
      if (key === 'certificationDivinationPriorityDisplay' || key === 'proPriorityDisplay') {
        this.$cookies.set('certification_divination_priority_display', value, {
          path: '/',
          maxAge: 60 * 60 * 24 * 365
        })
        this.$cookies.set('pro_priority_display', value, {
          path: '/',
          maxAge: 60 * 60 * 24 * 365
        })
      }
      if (emitChangeEvent) this.changeSearchForm(this.attributes)
    },
    async getSearchServices() {
      const fullPath = this.$route.fullPath
      const query = this.$route.query
      query.business_flag = this.isBusinessMode
      await this.$store
        .dispatch('pages/search/search/searchRequests', {
          params: this.$route.params,
          query: this.$util.castQueryFields(query),
          fullPath
        })
        .catch(({ grpcCode }) => {
          // $notifyはクライアント専用プラグイン
          if (process.client) {
            this.$notify({
              group: 'flash',
              title: 'システムエラーが発生しました',
              text: 'ブラウザを閉じて再度やり直してください',
              type: 'error',
              max: 1
            })
          } else {
            // NOTE: 一瞬サービス検索画面が表示されてしまい気持ち悪いが暫定対応
            // 本格対応するには検索処理など諸々をasyncDataやmiddlewareで行うようにする必要がある
            const statusCode = this.$util.grpcCodeToHttpStatusCode(grpcCode)
            this.$nuxt.context.error({ statusCode })
          }
        })
    },
    getSeo() {
      const camelParams = this.$util.toCamelCaseObject(this.$route.params)
      const camelQuery = this.$util.toCamelCaseObject(this.$route.query)

      const categoryId = toInt32(camelParams.categoryId || camelQuery.categoryId)
      const categoryTypeId = toInt32(camelParams.categoryTypeId || camelQuery.categoryTypeId)
      const keyword = camelQuery.keyword
      const serviceKind = String(camelQuery.serviceClass || camelQuery.serviceKind)
      const page = toInt32(camelQuery.page)
      const styleIds = toInt32Array(camelQuery.styleIds || [])
      const contentIds = toInt32Array(camelQuery.contentIds || [])
      const genreIds = toInt32Array(camelQuery.genreIds || [])
      const usageIds = toInt32Array(camelQuery.usageIds || [])
      const occupationIds = toInt32Array(camelQuery.occupationIds || [])
      const industryIds = toInt32Array(camelQuery.industryIds || [])
      const languageIds = toInt32Array(camelQuery.languageIds || [])
      const fileTypeIds = toInt32Array(camelQuery.fileTypeIds || [])
      const techniqueIds = toInt32Array(camelQuery.techniqueIds || [])
      const paperSizeIds = toInt32Array(camelQuery.paperSizeIds || [])
      const baseScopeIds = toInt32Array(camelQuery.baseScopeIds || [])
      const sexIds = toInt32Array(camelQuery.sexIds || [])

      const metadata = commonMetaData(this.$store.state)
      const request = new GetSeoRequest()
      if (categoryId) request.setMasterCategoryId(categoryId)
      if (categoryTypeId) request.setMasterCategoryTypeId(categoryTypeId)
      if (keyword) request.setKeyword(keyword)
      const categoryClass =
        serviceKind === SERVICE_KIND_VALUE.TEXT
          ? 'text'
          : serviceKind === SERVICE_KIND_VALUE.PHONE
          ? 'phone'
          : null
      if (categoryClass) request.setCategoryClass(categoryClass)
      if (page) request.setPage(page)

      request.setStyleIdsList(styleIds)
      request.setContentIdsList(contentIds)
      request.setGenreIdsList(genreIds)
      request.setUsageIdsList(usageIds)
      request.setOccupationIdsList(occupationIds)
      request.setIndustryIdsList(industryIds)
      request.setLanguageIdsList(languageIds)
      request.setFileTypeIdsList(fileTypeIds)
      request.setTechniqueIdsList(techniqueIds)
      request.setPaperSizeIdsList(paperSizeIds)
      request.setBaseScopeIdsList(baseScopeIds)
      request.setSexIdsList(sexIds)
      request.setServiceClass(toInt32(camelQuery.serviceClass))
      if (isValidServiceKind(serviceKind)) {
        request.setServiceKind(serviceKind)
      }

      return grpcClient({
        method: SeoService.GetSeo,
        request,
        metadata
      })
        .then(res => {
          this.$store.commit('pages/search/seo/RECEIVE', res)
          return res
        })
        .catch(err => {
          this.$sentry.captureException(err)
        })
    },
    async getParentCategoryTop() {
      const { params } = this.$route
      // 大カテチェック
      const parentCategory = this.masterCategories.find(
        x => x.id === Number(params.categoryId) && x.subCategories.length > 0
      )
      if (!parentCategory || !this.isParentCategoryTopFromQueries()) {
        this.parentCategoryTopData = null
        // 大カテチェックをパスしてる場合、開発環境でのみ注意喚起ログを出す
        if (process.env.NODE_ENV !== 'production' && parentCategory) {
          console.log(
            '%c大カテTOPとして判定されませんでした',
            'font-size: 24px; font-weight: bold; color: yellow;'
          )
          console.log(
            '%c大カテTOP用コンテンツを表示すべきURLであるか確認してください\n%o',
            'font-size: 14px;',
            this.$route.fullPath
          )
          console.log(
            '%c詳しくは下記のドキュメントを参照してください\n%o\n',
            'font-size: 14px;',
            'https://github.com/welself/coconala-web/tree/develop/docs/各画面資料/大カテTOP.md'
          )
        }
        return
      }
      const request = new GetTopRequest()
      request.setMasterCategoryId(parentCategory.id)
      request.setBusinessFlag(this.isBusinessMode)
      const metadata = commonMetaData(this.$store.state)
      this.parentCategoryTopData = await grpcClient({
        method: TopService.GetTop,
        request,
        metadata
      }).catch(err => {
        /**
         * 訴求コンテンツが表示されないだけでユーザーからは正常に検索できているように見えるので
         * ユーザーへのエラー通知はしないでおく
         */
        this.parentCategoryTopData = null
        this.$sentry.withScope(scope => {
          scope.setLevel('info')
          scope.setTag('methods', 'getParentCategoryTop')
          scope.setTag('categoryId', parentCategory.id)
          this.$sentry.captureException(err)
        })
      })
    },
    /**
     * クエリパラメータを元に大カテTOPであるか判定
     * @returns {boolean} 判定結果
     */
    isParentCategoryTopFromQueries() {
      // 大カテTOPとして見なさないクエリの存在チェック
      // 対象のクエリが含まれていた場合でも"0"の場合は大カテTOPとして見なす
      // (フラグ系のオンオフで大カテTOPに戻ってこれないのは不自然なため)
      const existsExcludedQuery = Object.entries(this.$route.query).some(([key, value]) => {
        // 例外判定
        // category_topの値がfalsyまたは'false'の文字列なら大カテTOPとして見なさない
        if (key === 'category_top' && (!value || value === 'false')) {
          return true
        }
        // サービスクラスは"0"の場合でも大カテTOPとして見なさない
        if (key === 'service_class' || key === 'service_kind') {
          return true
        }
        if (key === 'page') {
          // ページングで1ページ目に戻ってきたときにpage=1がつくのでその対応
          return Number(value) > 1
        }

        if (!EXCLUDED_QUERIES_PARENT_CATEGORY.includes(key)) {
          return false
        }
        if (Array.isArray(value)) {
          return value.length > 0
        }
        // 数字のみのクエリパラメータはSSR時はnumber、CSR時はstringとして認識されるのでその対応
        if (typeof value === 'string' && /^\d+$/.test(value)) {
          return !!Number(value)
        }
        return !!value
      })
      return !existsExcludedQuery
    },
    changeFullCorrespondence(value) {
      const attribute = {
        exclude_full_correspondence: value,
        categoryId: this.currentCategoryId
      }
      this.changeSearchForm(attribute)
    },
    changeSortType(value) {
      const attribute = {
        sort_by: value,
        categoryId: this.currentCategoryId
      }
      this.changeSearchForm(attribute)
    },
    changeSearchForm(query) {
      const snakeCaseRouteParams = this.$util.toSnakeCaseObject(this.$route.params)
      const snakeCaseRouteQuery = this.$util.toSnakeCaseObject(
        this.$util.castQueryFields(this.$route.query)
      )
      const snakeCaseQuery = this.$util.toSnakeCaseObject(query)
      const oldCategoryId = (() => {
        if (snakeCaseRouteParams.category_id) {
          return snakeCaseRouteParams.category_id
        }
        if (snakeCaseRouteQuery.category_id) {
          return snakeCaseRouteQuery.category_id
        }
        return null
      })()

      if (!snakeCaseQuery.category_id || isNaN(snakeCaseQuery.category_id)) {
        delete snakeCaseQuery['category_id']
      }

      if (!snakeCaseQuery.category_type_id || isNaN(snakeCaseQuery.category_type_id)) {
        delete snakeCaseQuery['category_type_id']
      }

      const newQuery = this.$util.omitFalsyAndBlankArray({
        ...snakeCaseRouteParams,
        ...snakeCaseRouteQuery,
        ...snakeCaseQuery
      })

      // this.$util.omitFalsyAndBlankArrayで[false]の値が入っているキーは削除されてしまうため、ここで再度URLのパラメータのcategory_topを見て、[false]だった時にnewQueryに値をセットする
      if (snakeCaseRouteQuery['category_top'] === false) {
        newQuery['category_top'] = false
      }

      delete newQuery['page']
      delete newQuery['business_flag'] // APIを叩くときに追加しているためクエリには不要

      // [NOTE] サービスの種類が変更された場合、urlのqueryからprice_min、price_maxを削除
      const isDeletePriceQuery = this.isServiceKindChanged(
        snakeCaseQuery.service_kind,
        snakeCaseRouteQuery.service_kind
      )
      if (isDeletePriceQuery) {
        delete newQuery['price_min']
        delete newQuery['price_max']
      }

      // 通常サービス以外の時は文字単価の検索条件は削除する
      if (snakeCaseQuery.service_kind && snakeCaseQuery.service_kind !== SERVICE_KIND_VALUE.TEXT) {
        delete newQuery['unit_price_min']
        delete newQuery['unit_price_max']
      }

      // ココナラ内での遷移時に設定し、ref_c=1の時はLPを表示しない
      newQuery['ref_c'] = 1

      if (
        oldCategoryId &&
        Number(oldCategoryId) !== Number(newQuery.category_id) &&
        newQuery.category_type_id
      ) {
        delete newQuery['category_type_id']
      }
      // PC且つLPが非表示の場合はスクロール位置を保持する
      if (this.isPC && !this.isLp) {
        newQuery['y'] = window.pageYOffset
      } else {
        delete newQuery['y']
      }
      // TODO: 初期値だったときにパラメータを削除したい
      if (newQuery.keyword) {
        this.$router.push(
          {
            path: '/search',
            query: newQuery
          },
          () => {}
        )
      } else if (newQuery.category_type_id) {
        const newCategoryId = newQuery.category_id
        const newMasterCategoryTypeId = newQuery.category_type_id
        delete newQuery['keyword']
        delete newQuery['category_id']
        delete newQuery['category_type_id']
        this.$router.push(
          {
            path: `/categories/${newCategoryId}/${newMasterCategoryTypeId}`,
            query: newQuery
          },
          () => {}
        )
      } else if (newQuery.category_id) {
        const newCategoryId = newQuery.category_id
        delete newQuery['keyword']
        delete newQuery['category_id']
        this.$router.push(
          {
            path: `/categories/${newCategoryId}`,
            query: newQuery
          },
          () => {}
        )
      } else {
        this.$router.push(
          {
            path: '/search',
            query: newQuery
          },
          () => {}
        )
      }
    },
    isServiceKindChanged(oldServiceKind, newServiceKind) {
      // 変更前・変更後のいずれかのservice_kindの値がundefinedの時は比較ができないためfalseをリターンする
      if (oldServiceKind === undefined || newServiceKind === undefined) {
        return false
      }
      // 一致しない場合はservice_kindが変更されているのでtrue
      return Number(oldServiceKind) !== Number(newServiceKind)
    },
    changeKeyword(searchText) {
      // 検索条件を強制リセットするためlocation.hrefにする
      const option = searchText ? { keyword: searchText } : null
      const url = this.$coconala.rootPathUrl('/search', option)
      location.href = this.addQueryToUrlIfBusinessPreview(url)
    },
    generateBread() {
      this.bread.breadcrumb = []
      // keywordは文字列なのでキャスト不要
      const keyword = this.$route.query.keyword
      const currentId = this.currentCategoryId
      const currentTitle = this.currentCategoryTitle
      const currentServiceClass = this.currentServiceClass
      const condition = this.search.searchCondition
      const firstCategory = condition.categoriesList[0]
      const currentCategoryTypeId = this.currentCategoryTypeId

      if (this.seo.isTrendKeywordPage) {
        // isTrendKeywordPage parentCategory
        const parentCategory = {
          id: firstCategory?.id,
          url: `/categories/${firstCategory?.id}`,
          isCurrent: false,
          name: firstCategory?.name
        }

        // テキストサービス且つtextSeoNameが有る場合にnameを変更
        if (currentServiceClass !== this.serviceClass.phone && firstCategory?.textSeoName) {
          parentCategory.name = firstCategory?.textSeoName
        }

        this.bread.breadcrumb.push(parentCategory)
      } else if (keyword && currentId) {
        const BreadKeywordAndCategory = {
          id: 0,
          url: this.$coconala.rootPathUrl('/search', {
            keyword: keyword,
            category_id: currentId
          }),
          isCurrent: true,
          name: `${currentTitle}カテゴリから「${keyword}」の検索結果`
        }
        this.bread.breadcrumb.push(BreadKeywordAndCategory)
      } else if (keyword) {
        const BreadKeyword = {
          id: 0,
          url: this.$coconala.rootPathUrl('/search', {
            keyword: keyword
          }),
          isCurrent: true,
          name: `すべてのカテゴリから「${keyword}」の検索結果`
        }
        this.bread.breadcrumb.push(BreadKeyword)
      } else if (currentId && condition.categoriesList.length) {
        const parentCategory = {
          id: firstCategory?.id,
          url: `/categories/${firstCategory?.id}`,
          isCurrent: firstCategory?.isCurrent,
          name: firstCategory?.name
        }

        // テキストサービス且つtextSeoNameが有る場合にnameを変更
        if (currentServiceClass !== this.serviceClass.phone && firstCategory?.textSeoName) {
          parentCategory.name = firstCategory?.textSeoName
        }

        // 電話サービスのときにisCurrentをfalseにする
        if (currentServiceClass === this.serviceClass.phone) {
          parentCategory.isCurrent = false
        }

        this.bread.breadcrumb.push(parentCategory)
      } else {
        const notSetCategory = {
          id: 0,
          url: '/search',
          isCurrent: true,
          name: 'すべてのカテゴリからの検索結果'
        }

        if (currentServiceClass === this.serviceClass.phone) {
          notSetCategory.name = 'すべてのカテゴリからの検索結果［電話］'
        }

        this.bread.breadcrumb.push(notSetCategory)
      }

      // 電話サービスの時に親カテと子カテの間にパンくずを追加
      if (currentId && currentServiceClass === this.serviceClass.phone) {
        const parentPhoneCategory = {
          id: `${firstCategory?.id}-phone`,
          url: `/categories/${firstCategory?.id}?service_kind=${this.serviceClass.phone}`,
          isCurrent: firstCategory?.isCurrent,
          name: `${firstCategory?.name}の電話相談`
        }

        // isTrendKeywordPageの場合リンク可にする
        // または、特定のタグページの場合小カテへリンク可にする
        if (this.seo.isTrendKeywordPage || this.isMixinBreadcrumbTechniques) {
          parentPhoneCategory.isCurrent = false
        }

        // 電話サービス且つphoneSeoNameが有る場合にnameを変更
        // または、電話サービス且つ占いカテゴリの時にnameを変更
        if (firstCategory?.phoneSeoName) {
          parentPhoneCategory.name = firstCategory?.phoneSeoName
        } else if (this.isParentCategoryDivinationPhone) {
          parentPhoneCategory.name = this.VIRTUAL_CATEGORY.DIVINATION_PHONE.NAME
        }

        this.bread.breadcrumb.push(parentPhoneCategory)
      }

      // 子カテのパンくず設定
      if (currentId && this.isChildCategory(condition, currentId)) {
        const sub = firstCategory?.subCategoriesList
        const childCategory = this.setChildCategory(sub, currentId)
        const childCategoryBreadcrumb = {
          id: childCategory.id,
          url: `/categories/${childCategory.id}`,
          isCurrent: childCategory.isCurrent,
          name: childCategory.name
        }

        if (
          // isTrendKeywordPageの場合小カテへリンク可にする
          this.seo.isTrendKeywordPage ||
          // カテゴリタイプがある場合小カテへリンク可にする
          currentCategoryTypeId ||
          // 特定のタグページの場合小カテへリンク可にする
          this.isMixinBreadcrumbTechniques
        ) {
          childCategoryBreadcrumb.isCurrent = false
        }

        // 電話サービスの場合、urlにservice_classを追加
        if (currentServiceClass === this.serviceClass.phone) {
          childCategoryBreadcrumb.url = `/categories/${childCategory.id}?service_kind=${this.serviceClass.phone}`
        }

        // テキストサービス且つtextSeoNameが有る場合にnameを変更
        // または、電話サービス且つphoneSeoNameが有る場合にnameを変更
        // または、電話サービス且つphoneSeoNameが無い場合にnameを変更（占いとそれ以外で付け方が違う）
        if (currentServiceClass !== this.serviceClass.phone && childCategory.textSeoName) {
          childCategoryBreadcrumb.name = childCategory.textSeoName
        } else if (currentServiceClass === this.serviceClass.phone && childCategory.phoneSeoName) {
          childCategoryBreadcrumb.name = childCategory.phoneSeoName
        } else if (currentServiceClass === this.serviceClass.phone && !childCategory.phoneSeoName) {
          if (this.isParentCategoryDivinationPhone) {
            childCategoryBreadcrumb.name = `［電話占い］${childCategory.name}`
          } else {
            childCategoryBreadcrumb.name = `${childCategory.name}［電話］`
          }
        }

        this.bread.breadcrumb.push(childCategoryBreadcrumb)
      }

      // カテゴリタイプのパンくず設定
      if (currentCategoryTypeId) {
        const categoryTypeBreadcrumb = {
          id: `categoryType-${currentCategoryTypeId}`,
          url: `/categories/${currentId}/${currentCategoryTypeId}`,
          isCurrent: true,
          name: this.currentCategoryTypeName
        }

        // 電話サービスの場合、urlにservice_classを追加
        if (currentServiceClass === this.serviceClass.phone) {
          categoryTypeBreadcrumb.url += `?service_kind=${this.serviceClass.phone}`
        }

        // 特定のタグページの場合小カテへリンク可にする
        if (this.isMixinBreadcrumbTechniques) {
          categoryTypeBreadcrumb.isCurrent = false
        }

        this.bread.breadcrumb.push(categoryTypeBreadcrumb)
      }

      // 特定のタグページの場合のみパンクズを追加
      if (this.isMixinBreadcrumbTechniques) {
        // タグページなので、技術は一つのみ選択している
        const technique = this.currentTechniques[0]

        const relativePath = currentCategoryTypeId
          ? `/categories/${currentId}/${currentCategoryTypeId}`
          : `/categories/${currentId}`
        const url = this.$coconala.rootPathUrl(relativePath, {
          service_class: currentServiceClass,
          'technique_ids[]': technique.value
        })

        const categoryDivinationTechniqueBreadcrumb = {
          id: 'category-divination-technique',
          url,
          isCurrent: true,
          name: technique.name
        }

        this.bread.breadcrumb.push(categoryDivinationTechniqueBreadcrumb)
      }

      if (this.seo.isTrendKeywordPage) {
        // isTrendKeywordPage keyword
        this.bread.breadcrumb.push({
          id: 0,
          url: this.$coconala.rootPathUrl('/search', {
            keyword: keyword,
            category_id: currentId
          }),
          isCurrent: true,
          name: keyword
        })
      }

      if (this.seo.tag) {
        const { id, type } = this.seo.tag
        const option = this.optionMastersList.find(x => x.keyCategoryId === `${type}${currentId}`)
        const value = option?.valuesList.find(x => x.value === String(id))
        if (option && value) {
          this.bread.breadcrumb.forEach(bc => {
            bc.isCurrent = false
          })
          this.bread.breadcrumb.push({
            id: `category-${currentId}-${type}-${id}`,
            url: `/categories/${currentId}?${type}[]=${id}`,
            isCurrent: true,
            name: value.name
          })
        }
      }
    },
    isChildCategory(condition, currentId) {
      return condition.categoriesList[0].subCategoriesList.some(
        category => category.id == currentId
      )
    },
    setChildCategory(sub, currentId) {
      return sub.find(category => category.id == currentId)
    },
    setKind() {
      if (this.$route.params.categoryId) {
        return 'category'
      }
      return 'search'
    },
    calcPosition(index) {
      return this.offset + index + 1
    },
    calcPrPosition(index) {
      return this.prOffset + index + 1
    },
    serviceUrlQuery(index, service) {
      const commonRef = {
        // 引継ぎ対象のrefパラメータがあれば検索結果のカセットに渡す
        ref: TAKEOVER_REFS.find(x => x === this.$route.query.ref),
        ref_kind: this.setKind(),
        ref_no: this.calcPosition(index)
      }

      const loginOnlyRef = this.isLoggedIn
        ? {
            pos: this.calcPosition(index),
            ref_sort: this.search.searchCondition.sortBy
              ? this.search.searchCondition.sortBy
              : SORT_DEFAULT_VALUE,
            ref_page: this.search.searchCondition.page,
            ref_category: this.search.searchCondition.masterCategoryId
          }
        : {}

      const businessBeforeLoginOnlyRef = this.isBusinessBeforeLogin ? { is_business: 1 } : {}

      const isServicePrService = this.isServicePrService(service)
      // NOTE: search.jsで挿入したonlyNormalServiceIndexとonlyPrServiceIndexを使用するため修正時はsearch.jsも要確認
      const servicePrRef = {
        spr_key: isServicePrService ? service.servicePr.sprKey : null,
        service_pr_uuid: isServicePrService ? service.servicePr.servicePrUuid : null,
        service_order: isServicePrService
          ? 'null'
          : this.calcPosition(service.onlyNormalServiceIndex),
        service_order_with_pr: this.calcPosition(index) + (this.hasPrService ? this.prOffset : 0),
        service_order_only_pr: isServicePrService
          ? this.calcPrPosition(service.onlyPrServiceIndex)
          : 'null'
      }

      return {
        ...commonRef,
        ...loginOnlyRef,
        ...businessBeforeLoginOnlyRef,
        ...servicePrRef
      }
    },
    // ココナラ内での遷移時に設定し、ref_c=1の時はLPを表示しない
    isRefC() {
      return Number(this.$route.query.ref_c) === 1
    },
    // pageの指定チェック
    isPage() {
      return this.$route.query.page
    },
    // SP画面下部のカテゴリリスト（accordion）で自動展開対象があれば開く
    pushDefaultOpenedCategoryIds() {
      if (Number.isInteger(this.defaultOpenedCategoryId)) {
        this.openedCategoryIds.push(this.defaultOpenedCategoryId)
      }
    },
    openSearchDrawer() {
      this.TOGGLE_SEARCH_DRAWER()
    },
    isServicePrService(service) {
      return service.hasOwnProperty('servicePr') && !!service.servicePr?.sprKey
    },
    isServicePrServiceList(service) {
      return service.hasOwnProperty('servicePr') && service.servicePr?.sprKeysList.length > 0
    },
    showServicePrService(service) {
      if (this.isServicePrServiceList(service)) {
        const impressionServices = this.search.searchResultsList.filter(s => {
          return service.servicePr.sprKeysList.includes(s.servicePr?.sprKey)
        })
        new ServicePrAccessor(this.$store.state).impressionPrService(
          impressionServices,
          this.search.searchCondition,
          this.search.servicePrMaxCount,
          this.search.servicePrRealCount
        )
      }
    },
    // 大カテTOPでGoogleオプティマイズの発火するイベントを設定
    setGoogleOptimizeEventToDataLayer() {
      if (process.client && this.isParentCategoryTop) {
        if (!Array.isArray(window.dataLayer)) {
          window.dataLayer = []
        }
        window.dataLayer.push({ event: 'optimize.category_page_contents_cut' })
      }
    }
  }
})
export default searchService
